import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () =>
            import('../app/core/modules/login/login.module').then(
                (m) => m.LoginModule
            ),
    },
    {
    path: 'login',
    loadChildren: () =>
        import('../app/core/modules/login/login.module').then(
            (m) => m.LoginModule
        ),
    },
    {
    path: 'dashboard',
    loadChildren: () =>
        import('../app/core/modules/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
        ),
    },
    {
    path: 'book',
    loadChildren: () =>
        import('../app/core/modules/books/books.module').then(
            (m) => m.BooksModule
        ),
    },
    {
    path: 'paper',
    loadChildren: () =>
        import('../app/core/modules/papers/papers.module').then(
            (m) => m.PapersModule
        ),
    },
     {
    path: 'campaign',
    loadChildren: () =>
        import('../app/core/modules/campaign/campaign.module').then(
            (m) => m.CampaignModule
        ),
    },
];


export class AppRoutingModule { }
